import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgAtsignGhost = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M3 12c0 5.625 3.375 9 9 9s9-3.375 9-9-3.375-9-9-9-9 3.375-9 9'
      opacity={0.2}
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M6.098 6.098C4.78 7.416 4 9.388 4 12s.78 4.584 2.098 5.902S9.388 20 12 20c1.15 0 2.178-.152 3.077-.433a1 1 0 0 1 .596 1.909C14.556 21.825 13.326 22 12 22c-3.013 0-5.54-.908-7.316-2.683C2.908 17.54 2 15.013 2 12s.908-5.54 2.684-7.316C6.459 2.908 8.987 2 12 2s5.54.908 7.317 2.684C21.092 6.459 22 8.987 22 12c0 1.845-.462 3.24-1.311 4.185-.859.953-1.996 1.315-3.064 1.315-.736 0-1.445-.17-2.039-.584a3 3 0 0 1-.523-.466c-1.79 1.356-3.806 1.746-5.51 1.067-2.063-.822-3.224-3.03-2.95-5.86.274-2.842 2.164-4.678 4.307-5.163 1.415-.32 2.938-.043 4.114.89a.999.999 0 0 1 1.73.783l-.53 5.062c-.064.603-.023 1.053.07 1.376.101.35.26.549.434.67.182.126.464.225.897.225.619 0 1.17-.2 1.577-.653.416-.463.798-1.317.798-2.847 0-2.612-.78-4.584-2.098-5.902S14.612 4 12 4s-4.584.78-5.902 2.098m8.46 3.824c-.67-1.306-1.964-1.759-3.206-1.478-1.31.297-2.568 1.43-2.76 3.404-.212 2.204.682 3.405 1.702 3.811.977.39 2.453.207 3.949-1.12a6.3 6.3 0 0 1-.01-1.518z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgAtsignGhost)
export default ForwardRef
